import { RootState } from "apps/store";

export const newRecordSelector = (state: RootState) => state.newRecord.newRecord

export const listNewRecordOfHorseSelector = (state: RootState) => state.newRecord.listNewRecordOfHorse

export const loadingNewRecordSelector = (state: RootState) => state.newRecord.loadingNewRecord

export const errorNewRecordSelector = (state: RootState) => state.newRecord.errorNewRecord
